module.exports = __webpack_public_path__ + "images/f056f0e9c9972e922e683a78d50eb2d430291fcc244f4a626f5dda296912f155.svg";